import { render, staticRenderFns } from "./PerfilGraficos.vue?vue&type=template&id=ad98b794&scoped=true"
import script from "./PerfilGraficos.vue?vue&type=script&lang=js"
export * from "./PerfilGraficos.vue?vue&type=script&lang=js"
import style0 from "./PerfilGraficos.vue?vue&type=style&index=0&id=ad98b794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad98b794",
  null
  
)

export default component.exports